import { PlatesImagingTaskDTO } from 'business/models/Models';
import PlateService from 'business/services/PlateService';
import { useExperimentStates } from 'components/Experiment/hooks';
import RMSvgIcon from 'components/customComponents/CommonComponents/RMSvgIcon';
import { LoadingModal } from 'components/modal';
import React, { useState } from 'react';
import { useRMDispatch } from 'redux/hooks';
import { togglePlateImaging } from 'redux/reducers/experimentDataReducer';

interface Props {
  hideModal: () => void;
}

const DisablePlateImagingModal = (props: Props) => {
  const { hideModal } = props;
  const { exp } = useExperimentStates();
  const dispatch = useRMDispatch();
  const [allPlates, setAllPlates] = useState(
    exp.plateDto.reduce((object, plate) => {
      object[plate.plateId] = plate.imagingTasksEnabled;
      return object;
    }, {}),
  );
  const [loading, setLoading] = useState<boolean>();

  const handleCheckboxChange = (plateId) => {
    setAllPlates((prevState) => ({
      ...prevState,
      [plateId]: !prevState[plateId],
    }));
  };

  const handlePlateImaging = async () => {
    setLoading(true);
    const plates = Object.entries(allPlates).map(
      ([plateId, imagingEnabled]) =>
        ({
          plateId: parseInt(plateId),
          imagingEnabled,
        } as PlatesImagingTaskDTO),
    );
    dispatch(togglePlateImaging({ plates }));
    await new PlateService().setPlatesImaging(plates);
    setLoading(false);
    hideModal();
  };

  return (
    <>
      <div id='imagetuning-disableplateimagingmodal-wrapper' className="flex flex-row bg-blue-300 rounded-md p-2 mb-2">
        <div  id="imagetuning-disableplateimagingmodal-iconwrapper" className="w-[10%]">
          <RMSvgIcon id="imagetuning-disableplateimagingmodal-icon-info" name="Info" className="fill-blue-700" />
        </div>
        <div id="imagetuning-disableplateimagingmodal-infomessage" className="w-[90%] text-blue-900">
          The plate will not be imaged when the plate is marked as disabled imaging plate
        </div>
      </div>
      <h5 id="imagetuning-disableplateimagingmodal-title">Experiment Plate</h5>
      <div id="imagetuning-disableplateimagingmodal-platelist" className="flex flex-col gap-1 border p-2 h-36 overflow-auto">
        {exp?.plateDto?.map((p) => (
          <div id={`imagetuning-disableplateimagingmodal-plateitem-${p.plateId}`}
            key={p.plateId} className="flex flex-row items-center gap-2">
            <input
              type="checkbox"
              id={`imagetuning-disableplateimagingmodal-checkbox-${p.plateId}`}
              checked={!allPlates[p.plateId]}
              onChange={() => handleCheckboxChange(p.plateId)}
              className="w-4 h-4"
            />
            <label 
              id={`imagetuning-disableplateimagingmodal-plateitem-label-${p.plateBarName}`}
              htmlFor={`plate_${p.plateId}`} className="m-0 p-0">
              {p.plateBarName}
            </label>
          </div>
        ))}
      </div>
      <div id="imagetuning-disableplateimagingmodal-actionbuttons" className="flex flex-row gap-2 justify-end border-t my-2">
        <button id="imagetuning-disableplateimagingmodal-cancelbutton"
          onClick={hideModal}
          className="uppercase rounded-md text-md py-1 px-3 bg-white"
          style={{ borderColor: '#000000', borderWidth: '1px' }}
        >
          Cancel
        </button>
        <button id="imagetuning-disableplateimagingmodal-confirmbutton"
          onClick={handlePlateImaging}
          disabled={loading}
          className="uppercase rounded-md text-white py-1 px-3 border-none bg-orange-400 text-md disabled:opacity-70"
        >
          Confirm
        </button>
      </div>
      <LoadingModal showModal={loading} text="In Progress" />
    </>
  );
};

export default DisablePlateImagingModal;
